<template>
  <div id="basic-info" class="card mt-4">
    <div class="card-header">
      <h5>기본 정보</h5>
    </div>
    <div class="card-body pt-0">
      <!-- 이름 -->
      <div class="row mt-4">
        <div class="col-6">
          <material-input
            id="name"
            variant="static"
            label="이름"
            v-model="localData.name"
          />
        </div>
        <div class="col-6">
          <material-input
            id="email"
            type="email"
            variant="static"
            label="이메일"
            v-model="localData.email"
            disabled
          />
        </div>
      </div>

      <!-- 계정 생성일 (읽기 전용) -->
      <div class="row mt-4" v-if="basicData?.created_at">
        <div class="col-12">
          <div class="input-group input-group-static">
            <label>계정 생성일</label>
            <input
              type="text"
              class="form-control"
              :value="formatDate(basicData.created_at)"
              disabled
            />
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-4">
        <material-button
          color="dark"
          variant="gradient"
          size="sm"
          @click="saveChanges"
        >
          정보 저장
        </material-button>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  name: "BasicInfoCard",
  components: {
    MaterialInput,
    MaterialButton,
  },
  props: {
    basicData: {
      type: Object,
      default: () => ({}),
    },
    isUser: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update-field", "save-changes"],
  data() {
    return {
      localData: {
        name: "",
        email: "",
      },
      isInitializing: false,
    };
  },
  watch: {
    basicData: {
      handler(newData) {
        if (newData) {
          this.localData = {
            name: newData.name || "",
            email: newData.email || "",
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    saveChanges() {
      // 변경사항을 원본 데이터와 비교하여 전송
      const changes = {};

      Object.keys(this.localData).forEach(key => {
        // 에디터가 아닐 경우 메모는 전송 대상에서 제외
        const originalValue = this.basicData[key] || "";
        const currentValue = this.localData[key];

        if (originalValue !== currentValue) {
          changes[key] = currentValue;
        }
      });

      // 각 변경사항을 부모에게 emit
      Object.keys(changes).forEach(key => {
        this.$emit("update-field", { field: key, value: changes[key] });
      });

      // 저장 이벤트 emit
      this.$emit("save-changes");
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleString("ko-KR");
    },
  },
};
</script>
